(function () {
  const announcementSlider = () => {
    $(".announcement-bar__slide").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      if ($(".announcement-bar")) {
        $(this).addClass("slider_started");
      }

      const announcementId = $(this).data("announcement-id");
      const autoplay = $(this).data("autoplay");
      const autoplaySpeed = $(this).data("autoplay-speed") || 4;

      const announcementSwiper = new Swiper(
        `.announcement-js-${announcementId}`,
        {
          loop: true,
          navigation: {
            nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
            prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
          },
          ...(autoplay === true || autoplay === "true" ? {
            autoplay: {
              delay: autoplaySpeed * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          } : {}),
        }
      );
    });
  };

  announcementSlider();
  document.addEventListener("shopify:section:load", function () {
    announcementSlider();
  });
})();